interface CustomEventParams {
  bubbles?: boolean;
  cancelable?: boolean;
  detail?: unknown;
}

export const createCustomEvent = (name: string, params?: CustomEventParams) => {
  function CustomEvent(): CustomEvent<unknown> {
    params = params || { bubbles: false, cancelable: false, detail: null };
    const evt: CustomEvent<unknown> = document.createEvent("CustomEvent");
    evt.initCustomEvent(name, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  return CustomEvent();
};
